export const snfCanvasPadding = 10;
